import React from 'react';
import './filter.scss';
import FilterCard from './FilterCard';
import FilterDetails from './FilterDetails';
import { useSelector } from 'react-redux';

const Filter = ({productID, searchProductID}) => {
  const productsList = useSelector((state) => state.products.items); 
  const searchProductsList = useSelector((state) => state.search.items); 
  const filteredProducts = searchProductID 
    ? searchProductID
    : productID;
  return (
    <div className='filter'>
        <FilterCard itemDetails={filteredProducts} />
        <FilterDetails itemDetails={filteredProducts}/>
    </div>
  )
}

export default Filter
